module.exports = __webpack_public_path__ + "img/b3.61b5d838.png";